import { ICommand, IQuery } from 'core-ts-types';
import { IReminderToDo, ReminderFilterServant } from 'data-ng-personal-reminders';
import * as _4 from 'lodash4';
import { IToDo } from './../servants/to_do_builder_servant';
import { TodoFilterServant } from './../servants/to_do_filter_servant';
import { TodoDateRangeService } from './todo_date_range_service';
import { IStaffDrivenToDo, IStaffDrivenData, StaffTodoFilterServant, StaffTodoService } from 'data-ng-staff-todos';

interface ITodosFlags {
  isReminderEnabled: boolean;
  isMoreLoading: boolean;
}

export class TodosContentService {
  private flags: ITodosFlags;
  private activeFilter: any;
  private mandatoryTodos: Array<IReminderToDo | IToDo | IStaffDrivenToDo>;
  private mandatoryUpcomingTodos: Array<IReminderToDo | IToDo | IStaffDrivenToDo>;
  private shouldDoTodos: Array<IReminderToDo | IToDo>;
  private tips: Array<IReminderToDo | IToDo>;
  private filterMethod: () => Array<IReminderToDo | IToDo | IStaffDrivenToDo>;

  constructor(
    private $state: ng.ui.IStateService,
    private FEATURE_PERSONAL_REMINDERS: string,
    private EventCategoryEnum: any,
    private TodoFilterEnum: any,
    private TaskStatusEnum: any,
    private appConfigModel: any,
    private ngReminderFilterServant: ReminderFilterServant,
    private ngStaffTodoFilterServant: StaffTodoFilterServant,
    private ngTodoFilterServant: TodoFilterServant,
    private ngTodoDateRangeService: TodoDateRangeService,
    private loadPathTasksCommand: ICommand,
    private loadAllReminderDateRangeCommand: ICommand,
    private loadStaffTodoCommand: ICommand,
    private ngTipToDoQuery: IQuery,
    private ngShouldDoToDoQuery: IQuery,
    private ngMustDoToDoQuery: IQuery,
    private ngReminderListQuery: IQuery,
    private ngOverdueToDoQuery: IQuery,
    private $q: ng.IQService,
    private ngStaffTodoService: StaffTodoService
  ) {
    this.flags = {
      isReminderEnabled: appConfigModel.isFeatureEnabled(FEATURE_PERSONAL_REMINDERS),
      isMoreLoading: false
    };
  }

  initialize(activeFilter: any) {
    this.activeFilter = activeFilter;

    this.filterMethod = this.TodoFilterEnum.isReminder(this.activeFilter)
      ? this.ngReminderFilterServant.filterStrategy.getByKey(this.activeFilter.servantMethod)
      : this.ngTodoFilterServant.filterStrategy.getByKey(this.activeFilter.servantMethod);

    this.ngStaffTodoService.loadStaffTodos(this.ngTodoDateRangeService.getCurrentDateRange()).then(() => {
      this.loadTodosAndReminders();
    });
    this.shouldDoTodos = this.ngShouldDoToDoQuery.result;
    this.tips = this.ngTipToDoQuery.result;
  }

  loadTodosAndReminders(): void {
    //if there's an active filter, get the data from the filter method
    this.mandatoryTodos = this.filterMethod();
    if (this.TodoFilterEnum.isReminder(this.activeFilter)) {
      return;
    }

    // unless it's the all todos and events page, we don't need to load upcoming todos or personal reminders
    this.mandatoryUpcomingTodos = [];

    if (this.TodoFilterEnum.isAllTodoAndEvent(this.activeFilter)) {
      this.mandatoryUpcomingTodos = _4.difference(this.ngTodoFilterServant.activeToDosAndEvents(), this.mandatoryTodos);
      // every todo that's active but not included in "today's todos and events" are included in upcoming todos
      this.mandatoryTodos = this.mergeTodosAndReminders(
        this.mandatoryTodos,
        this.ngReminderFilterServant.remindersForToday()
      );
      this.mandatoryUpcomingTodos = this.mergeTodosAndReminders(
        this.mandatoryUpcomingTodos,
        this.ngReminderFilterServant.upcomingReminders()
      );
    }
  }

  mergeTodosAndReminders(
    todos: Array<IReminderToDo | IToDo | IStaffDrivenToDo>,
    reminders: Array<IReminderToDo | IToDo | IStaffDrivenToDo>
  ): Array<IReminderToDo | IToDo | IStaffDrivenToDo> {
    let mergedTodos = _4.union(todos, reminders);
    mergedTodos = _4.sortBy(mergedTodos, ({ task }) => {
      if (task.category && task.category === this.EventCategoryEnum.PERSONAL_REMINDER) {
        return moment((task as any).due_dt);
      }
      return (task as any).end_ts;
    });

    return mergedTodos;
  }

  isDefaultFilter(): boolean {
    return this.TodoFilterEnum.isAllTodoAndEvent(this.activeFilter);
  }

  resetFilter(): void {
    this.$state.get('my.todos').data.viewTitle = 'To-dos Landing Page';
    this.$state.go('my.todos', { filterBy: 'all' });
  }

  isMandatoryTodayEmpty(): boolean {
    return _4.isEmpty(this.mandatoryTodos);
  }

  isMandatoryUpcomingEmpty(): boolean {
    return _4.isEmpty(this.mandatoryUpcomingTodos);
  }

  showMore(): void {
    if (!this.flags.isMoreLoading) {
      this.flags.isMoreLoading = true;
      const dateRange = this.ngTodoDateRangeService.getShowMoreDateRange();
      this.$q
        .all([
          this.loadPathTasksCommand(dateRange),
          this.loadAllReminderDateRangeCommand(dateRange),
          this.loadStaffTodoCommand(dateRange)
        ])
        .finally(() => {
          this.flags.isMoreLoading = false;
          this.loadTodosAndReminders();
        });
    }
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/services/my_todos_content_service.ts